// 261005 E5 — chiếu nội dung của chặng vào khe của vỏ (thanh trái / thanh trên). Khe chưa gắn ⇒ không vẽ gì.
import React from 'react';
import { createPortal } from 'react-dom';

const WbSlot: React.FC<{ to: HTMLElement | null; children: React.ReactNode }> = ({ to, children }) => (to ? createPortal(children, to) : null);

export default WbSlot;

/** Chấm trạng thái 6px (xong / cần xem / lỗi / đang chạy / chưa). */
export const Dot: React.FC<{ tone: 'ok' | 'warn' | 'bad' | 'idle' | 'run'; title?: string }> = ({ tone, title }) => (
  <span className={`wb-dot wb-dot-${tone}`} title={title} aria-hidden="true" />
);

/** Một dòng kẻ mảnh: chấm + chữ + (nút) — thay Alert màu / dải nền vàng. */
export const Strip: React.FC<{ tone?: 'ok' | 'warn' | 'bad' | 'idle' | 'run'; action?: React.ReactNode; role?: string; children: React.ReactNode }> = ({ tone = 'idle', action, role, children }) => (
  <div className="wb-strip" role={role}>
    <Dot tone={tone} />
    <span className="wb-strip-t">{children}</span>
    {action && <span className="wb-strip-a">{action}</span>}
  </div>
);

/** Pill trạng thái (bo 999, 11px đậm): ok xanh · warn cam · todo xám · bad đỏ · ind chàm. */
export const Pill: React.FC<{ tone: 'ok' | 'warn' | 'todo' | 'bad' | 'ind' | 'acc'; title?: string; children: React.ReactNode }> = ({ tone, title, children }) => (
  <span className={`wb-pill-s wb-pill-${tone}`} title={title}>{children}</span>
);

/** Biểu tượng "!" trong tròn cam / đỏ — đầu mỗi dòng "Cần xem". */
export const Bang: React.FC<{ tone?: 'warn' | 'bad' }> = ({ tone = 'warn' }) => <span className={`wb-bang wb-bang-${tone}`} aria-hidden="true">!</span>;
